import React from "react";
import Link from "next/link";
import { FooterTargetDefense, FooterNavSection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData } from "@storyblok/react";

interface FooterProps {
  blok: FooterTargetDefense & SbBlokData;
}

const Footer: React.FC<FooterProps> = ({ blok }) => {
  if (!blok) return null;
  const { contact_number, navigation_sections } = blok;

  if (!navigation_sections || navigation_sections.length === 0) {
    return null;
  }

  // Split navigation sections into defined groups
  const firstColumn = navigation_sections.slice(0, 1);
  const secondColumn = navigation_sections.slice(1, 4);
  const thirdColumn = navigation_sections.slice(4, 7);
  const lastColumn = navigation_sections.slice(7);

  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          {/* First Column */}
          {firstColumn.map((section: FooterNavSection) => (
            <div className="col-24 col-sm-12 col-md-6" key={section._uid}>
              {section.title && (
                <div className="footer-text fw-normal mb-0">{section.title}</div>
              )}
              {section.links && (
                <ul className="list-unstyled footer-list mb-3">
                  {section.links.map((link) => (
                    <li key={link._uid}>
                      <Link
                        href={link.link?.cached_url || "#"}
                        target={link.external ? "_blank" : "_self"}
                      >
                        {link.text || "Unnamed Link"}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          {/* Second Column */}
          {secondColumn.length > 0 && (
            <div className="col-24 col-sm-12 col-md-6">
              {secondColumn.map((section: FooterNavSection) => (
                <div key={section._uid}>
                  {section.title && (
                    <div className="footer-text fw-normal mb-0">
                      {section.title}
                    </div>
                  )}
                  {section.links && (
                    <ul className="list-unstyled footer-list mb-3">
                      {section.links.map((link) => (
                        <li key={link._uid}>
                          <Link
                            href={link.link?.cached_url || "#"}
                            target={link.external ? "_blank" : "_self"}
                          >
                            {link.text || "Unnamed Link"}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Third Column */}
          {thirdColumn.length > 0 && (
            <div className="col-24 col-sm-12 col-md-6">
              {thirdColumn.map((section: FooterNavSection) => (
                <div key={section._uid}>
                  {section.title && (
                    <div className="footer-text fw-normal mb-0">
                      {section.title}
                    </div>
                  )}
                  {section.links && (
                    <ul className="list-unstyled footer-list mb-3">
                      {section.links.map((link) => (
                        <li key={link._uid}>
                          <Link
                            href={link.link?.cached_url || "#"}
                            target={link.external ? "_blank" : "_self"}
                          >
                            {link.text || "Unnamed Link"}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Last Column */}
          {lastColumn.length > 0 && (
            <div className="col-24 col-sm-12 col-md-6">
              {lastColumn.map((section: FooterNavSection) => (
                <div key={section._uid}>
                  {section.title && (
                    <div className="footer-text fw-normal mb-0">
                      {section.title}
                    </div>
                  )}
                  {section.links && (
                    <ul className="list-unstyled footer-list mb-3">
                      {section.links.map((link) => (
                        <li key={link._uid}>
                          <Link
                            href={link.link?.cached_url || "#"}
                            target={link.external ? "_blank" : "_self"}
                          >
                            {link.text || "Unnamed Link"}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer Bottom Section */}
        <div className="row mt-4">
          <div className="col-24">
            <p className="footer-text">
              &copy; 2020-{new Date().getFullYear()}{" "}
              <Link href="/" className="footer-link" aria-label="Target Defense">
                Target Defense Inc.
              </Link>{" "}
              All rights reserved.{" "}
              {contact_number && (
                <Link
                  href={`tel:${contact_number.replace(/\D/g, "")}`}
                  className="footer-link"
                >
                  {contact_number}
                </Link>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;